import React from 'react';
import styled from 'styled-components';
import buttonIcon from '../assets/back-to-top.svg';

const Button = styled.div`
  position: fixed;
  right: 20px;
  bottom: 35px;
  width: 40px;
  height: 40px;
  padding: 5px;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 6;
  > img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    display: block;
  }
`;

const ScrollToTop = () => {
  const onClickHandler = () => {
    if (window) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
  return (
    <Button
      onClick={onClickHandler}
    >
      <img src={buttonIcon} alt="backto top button" />
    </Button>
  );
};

export default ScrollToTop;
